import { Routes } from '@angular/router'
import { CanvasComponent } from '@shared/components/canvas/canvas.component'
import { ChatComponent } from '@shared/components/chat/chat.component'

export const routes: Routes = [
  { path: 'chat', component: ChatComponent },
  { path: 'canvas', component: CanvasComponent },
]
